import { render, staticRenderFns } from "./service-hook-list.component.vue?vue&type=template&id=74f83e53&scoped=true&"
import script from "./service-hook-list.component.vue?vue&type=script&lang=ts&"
export * from "./service-hook-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./service-hook-list.component.vue?vue&type=style&index=0&id=74f83e53&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f83e53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
